import { NgModule, APP_INITIALIZER, Injector } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { providePrimeNG } from 'primeng/config';
import { CgatePrimeNgPreset, PRIMENG_DARK_MODE_SELECTOR } from './primeng-theme';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withXsrfConfiguration } from '@angular/common/http';
import { HttpClientInMemoryWebApiModule } from 'angular-in-memory-web-api';
import { ClipboardModule } from 'ngx-clipboard';
import { TranslateModule } from '@ngx-translate/core';
import { InlineSVGModule } from 'ng-inline-svg-2';
import {
  NgbModule,
  NgbDateParserFormatter,
  NgbDatepickerI18n,
} from '@ng-bootstrap/ng-bootstrap';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { WorkflowUrlTaskFloatComponent } from './pages/project-management/workflow-url-task-float/workflow-url-task-float.component';
import { AuthService } from './modules/auth/services/auth.service';
import { environment } from '../environments/environment';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
// #fake-start#
import { FakeAPIService } from './_fake/fake-api.service';
import { JwtInterceptor } from './modules/auth/helpers/jwt.interceptor';
import { ErrorInterceptor } from './modules/auth/helpers/error.interceptor';
import { SsoInterceptor } from './modules/auth/helpers/sso.interceptor';
import { PermissionHttpInterceptor } from './core/permissions/permission-http.interceptor';
import { ToastrModule, ToastrService } from 'ngx-toastr';
import { CustomDateParserFormatter } from './_metronic/shared/customDateParserFormatter';
import { CustomDatepickerI18n } from './_metronic/shared/custom-datepicker-i18n.service';
import { CarbonCalculateComponent } from './pages/carbon-calculate/carbon-calculate.component';
// #fake-end#

function appInitializer(authService: AuthService) {
  return () => {
    return new Promise((resolve) => {
      //@ts-ignore
      authService.getUserByToken().subscribe().add(resolve);
    });
  };
}

@NgModule({ declarations: [AppComponent],
    bootstrap: [AppComponent], imports: [WorkflowUrlTaskFloatComponent,
        BrowserModule,
        BrowserAnimationsModule,
        TranslateModule.forRoot(),
        ClipboardModule,
        FormsModule,
        ReactiveFormsModule,
        // #fake-start#
        environment.isMockEnabled
            ? HttpClientInMemoryWebApiModule.forRoot(FakeAPIService, {
                passThruUnknownUrl: true,
                dataEncapsulation: false,
            })
            : [],
        // #fake-end#
        AppRoutingModule,
        InlineSVGModule.forRoot(),
        NgbModule,
        ToastrModule.forRoot({
            positionClass: 'toast-top-right',
            timeOut: 5000,
            extendedTimeOut: 2000,
            closeButton: true,
            progressBar: true,
            progressAnimation: 'decreasing',
            maxOpened: 5,
            autoDismiss: true,
            newestOnTop: true,
            preventDuplicates: true,
            resetTimeoutOnDuplicate: true,
            includeTitleDuplicates: true,
        })], providers: [
        providePrimeNG({ theme: { preset: CgatePrimeNgPreset, options: { darkModeSelector: PRIMENG_DARK_MODE_SELECTOR } } }),
        {
            provide: APP_INITIALIZER,
            useFactory: appInitializer,
            multi: true,
            deps: [AuthService],
        },
        { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: SsoInterceptor, multi: true },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: PermissionHttpInterceptor,
            multi: true,
        },
        { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
        { provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n },
        provideHttpClient(withInterceptorsFromDi(), withXsrfConfiguration({
            cookieName: 'XSRF-TOKEN',
            headerName: 'X-XSRF-TOKEN',
        })),
    ] })
export class AppModule {
  static injector: Injector;
  constructor(injector: Injector) {
    AppModule.injector = injector;
  }
}
